'use client';

import { getImageProps, ImageProps } from 'next/image';

import { loadApproperiateImage, nextImageWrapper } from '@/helpers/utils/cloudflare';

type CarouseImageProps = Pick<ImageProps, 'priority' | 'loading'> & {
  mobileImage: string | ImageProps['src'];
  desktopImage: string | ImageProps['src'];
  tabletImage: string | ImageProps['src'];
};

export default function CarouselImage({ mobileImage, desktopImage, tabletImage, ...restProps }: CarouseImageProps) {
  const common = {
    alt: 'pawTree Banner',
    width: 1080,
    height: 300,
    layout: 'responsive',
    className: 'w-full',
    ...restProps,
  };
  const {
    props: { srcSet: mobile },
  } = getImageProps({
    ...common,
    loader: ({ src, width: w }) => {
      return typeof mobileImage === 'string' ? nextImageWrapper(loadApproperiateImage(mobileImage, 'public'), w) : src;
    },
    src: typeof mobileImage === 'string' ? nextImageWrapper(loadApproperiateImage(mobileImage, 'public')) : mobileImage,
  });
  const {
    props: { srcSet: tablet },
  } = getImageProps({
    ...common,
    loader: ({ src, width: w }) => {
      return typeof tabletImage === 'string' ? nextImageWrapper(loadApproperiateImage(tabletImage, 'public'), w) : src;
    },
    src: typeof tabletImage === 'string' ? nextImageWrapper(loadApproperiateImage(tabletImage, 'public')) : tabletImage,
  });
  const {
    props: { srcSet: desktop, ...rest },
  } = getImageProps({
    ...common,
    src: typeof desktopImage === 'string' ? nextImageWrapper(loadApproperiateImage(desktopImage, 'hd')) : desktopImage,
    loader: ({ src, width: w }) => {
      return typeof desktopImage === 'string' ? nextImageWrapper(loadApproperiateImage(desktopImage, 'hd'), w) : src;
    },
  });

  return (
    <picture>
      <source media="(max-width: 600px)" srcSet={mobile} />
      <source media="(max-width: 768px)" srcSet={tablet} />
      <source media="(min-width: 769px)" srcSet={desktop} />
      <img {...rest} />
    </picture>
  );
}
